<template>
  <div class="card-about-num-container">
    <div class="top-container orange-title">
      <div class="num-title-container orange-title">
        {{ item.title }}
      </div>
      <div class="mini-title-container" v-if="item.miniTitle">
        {{ item.miniTitle }}
      </div>
    </div>
    <div class="medium-title-container">
      {{ item.text }}
    </div>
  </div>
</template>

<script>
import BigTitle from "@/components/shared/text/BigTitle.vue";

export default {
  name: "CardAboutNum",
  components: {BigTitle},
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.card-about-num-container {
  display: flex;
  flex-direction: column;
  height: fit-content;
  .top-container {
    display: flex;
    flex-direction: row;
    align-items: baseline;
  }
}



@media (max-width: 3024px){
  .card-about-num-container {
    max-width: 345px;
    .top-container {
      column-gap: 8px;

      .num-title-container {
        font-size: 72px;
      }
      .mini-title-container {
        font-size: 32px;
      }
    }
    .medium-title-container{
      font-size: 24px;
    }
  }
}


@media (max-width: 1920px) {
  .card-about-num-container {
    max-width: 270px;
    .top-container {
      column-gap: 8px;


      .num-title-container {
        font-size: 52px;
      }
      .mini-title-container {
        font-size: 28px;
      }
    }
    .medium-title-container{
      font-size: 20px;
    }
  }
}


@media (max-width: 1600px) {
  .card-about-num-container {
    max-width: 230px;
    .top-container {
      column-gap: 8px;

      .num-title-container {
        font-size: 42px;
      }
      .mini-title-container {
        font-size: 20px;
      }
    }
    .medium-title-container{
      font-size: 16px;
    }
  }
}

@media (max-height: 800px) {
  .card-about-num-container {
    max-width: 175px;
    .top-container {
      column-gap: 8px;

      .num-title-container {
        font-size: 32px;
      }
      .mini-title-container {
        font-size: 16px;
      }
    }
    .medium-title-container{
      font-size: 14px;
    }
  }
}

@media (max-width: 1400px) and (min-height: 801px) {
  .card-about-num-container {
    max-width: 230px;
    .top-container {
      column-gap: 8px;


      .num-title-container {
        font-size: 42px;
      }
      .mini-title-container {
        font-size: 20px;
      }
    }
    .medium-title-container{
      font-size: 16px;
    }
  }
}

@media (max-width: 1133px) {
  .card-about-num-container {
    max-width: 175px;
    .top-container {
      column-gap: 8px;


      .num-title-container {
        font-size: 32px;
      }
      .mini-title-container {
        font-size: 16px;
      }
    }
    .medium-title-container{
      font-size: 14px;
    }
  }
}

@media (max-width: 769px) {
  .card-about-num-container {
    max-width: 175px;
    .top-container {
      column-gap: 8px;
      .num-title-container {
        font-size: 36px;
      }
      .mini-title-container {
        font-size: 16px;
      }
    }
    .medium-title-container{
      font-size: 14px;
    }
  }
}

@media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
  //plus
}

@media (min-height: 600px) and (max-height: 630px){

  //8 plus
}

@media (max-width: 375px) {
  //se new
}

@media (max-width: 375px) and (min-height: 630px) {
  //x
}


@media (max-width: 320px) {
  //se old
}

@media (min-width: 3025px) {
  .card-about-num-container {
    max-width: 638px;
    .top-container {
      column-gap: 16px;
      .num-title-container {
        font-size: 140px;
      }
      .mini-title-container {
        font-size: 54px;
      }
    }
    .medium-title-container{
      font-size: 46px;
    }
  }
}

</style>